import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import wordmarkWhite from 'assets/images/logo-wordmark-white.svg'
import WaLogo from 'assets/images/logo-white.png'
import { IRootReduxState } from 'types/reducers'
import { useSelector } from 'react-redux'

const useStyles = makeStyles(() => ({
  logo: (props: any) => ({
    width: props.width ? `${props.width}px` : 'auto',
    height: 'auto',
    display: 'block',
  }),
}))

interface Props {
  width?: number
  variant?: 'lockscreen' | 'sidebar'
}

const Branding: React.FC<Props> = ({ width, variant = 'sidebar' }) => {
  const classes = useStyles({ width })
  const expanded = useSelector((state: IRootReduxState) => state.app.state.sideMenuExpanded)

  // Sidebar collapsed → show only the small gradient icon
  // Sidebar expanded / lockscreen → show full white wordmark
  const src = variant === 'sidebar' && !expanded ? WaLogo : wordmarkWhite

  return (
    <img src={src} className={classes.logo} alt="WorkAware" />
  )
}

export default Branding
